import { apiClient } from '../services/api-client';

/**
 * DELETEs a FHIR resource through the `/fhir` proxy.
 *
 * The response is unvalidated JSON, so `TResponse` is an unchecked claim confined
 * to this boundary rather than validation — see the note in `FHIRFetcher`. It defaults
 * to `fhir4.OperationOutcome`, what FHIR's `delete` interaction answers with; no call
 * site reads the result.
 */
const FHIRDelete = async <TResponse = fhir4.OperationOutcome>(
  endPoint: string,
  token: string,
): Promise<TResponse> => {
  const dataEndPoint = '/fhir' + endPoint;

  const result = await apiClient.del<TResponse>('fhir-proxy', dataEndPoint, {
    headers: {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
  });
  return result;
};

export default FHIRDelete;
